/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { superBoxStyle } from '@vital-ui/react-utils';
export var ButtonGroup = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > button:not(:last-child) {\n    margin-right: ", ";\n  }\n\n  > button {\n    display: inline-block;\n  }\n  ", ";\n"], ["\n  > button:not(:last-child) {\n    margin-right: ",
    ";\n  }\n\n  > button {\n    display: inline-block;\n  }\n  ", ";\n"])), function (_a) {
    var vertical = _a.vertical, marginHorizontal = _a.marginHorizontal;
    return vertical ? 0 : marginHorizontal;
}, superBoxStyle);
ButtonGroup.defaultProps = {
    marginHorizontal: '5px',
    vertical: false,
};
var templateObject_1;
//# sourceMappingURL=ButtonGroup.js.map